import Button from "../../base/Button";

const renderIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="23"
        viewBox="0 0 23 23"
    >
        <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2">
            <path d="M7.375 7.5l8 8M7.375 21.5l-5.586-5.586a2 2 0 0 1 0-2.828L12.742 2.133a2 2 0 0 1 2.828 0l5.172 5.172a2 2 0 0 1 0 2.828L9.375 21.5" />
            <path strokeLinecap="square" d="M2.375 21.5h18" />
        </g>
    </svg>
);

/**
 * Toolbar button for clearing the current highlight.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered clear button.
 */
const ClearButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default ClearButton;
